export const RuleTypes = {
  DeviceOffline: "device.offline",
  DeviceEvent: "device.event",
  Movement: "subject.session.epochs.movement",
  NoPresence: "subject.session.epochs.no-presence",
  RRDeviation: "subject.sessions.respiration-rate-trend-deviation",
  SoundLevel: "subject.session.epochs.sound-level",
  Awake: "subject.session.epochs.awake",
  FallDetected: "subject.fall-detected",
} as const;

export type RuleType = (typeof RuleTypes)[keyof typeof RuleTypes];
